import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../src/core/api/axiosClient";

const initialState: any = {
  motionHeatMapReports: [],
  filterFormConfig: {},
  tcOptions: [],
  siteOptions: [],
  blockOptions: [],
  isLoading: false,
  error: null,
  motionHeatmapReportsDownload: [],
  isLoadingMotionHeatmapReportsDownload: false,
};

export const getMotionHeatMapReports: any = createAsyncThunk(
  "content/getMotionHeatMapReports",
  async ({
    tcCode = null,
    siteCode = null,
    blockCode = null,
    location = null,
    reportType = null,
    startDate = null,
    // endDate = null,
    floorPlan = null,
    asset = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      location,
      reportType,
      startDate,
      // endDate,
      floorPlan,
      asset,
    };

    const res = await axios.post(
      `/slpapp/Report/getMotionHeatMapReport`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const data = await res.data;
    return data;
  },
);

export const downloadMotionHeatMapReportsFile: any = createAsyncThunk(
  "content/downloadMotionHeatMapReportsFile",
  async ({
    fileType = "downloadPdf",
    tcCode = null,
    siteCode = null,
    blockCode = null,
    location = null,
    reportType = null,
    startDate = null,
    // endDate = null,
    floorPlan = null,
    asset = null,
  }: any) => {
    const payload = {
      tcCode,
      siteCode,
      blockCode,
      location,
      reportType,
      startDate,
      // endDate,
      floorPlan,
      asset,
    };

    try {
      const response = await axios.post(
        `/slpapp/Report/getMotionHeatMapReport/${fileType}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        },
      );

      let filename = response.headers["content-disposition"]
        .split(";")
        .find((n: any) => n.includes("filename="))
        .replace("filename=", "")
        .trim();
      console.log("fileType === downloadPdf ", fileType === "downloadPdf");
      let fileBlob;
      if (fileType === "downloadPdf") {
        fileBlob = new Blob([response.data], { type: "application/pdf" });
      } else {
        fileBlob = new Blob([response.data], {
          type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
      }

      const fileUrl = URL.createObjectURL(fileBlob);

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = filename;

      link.click();

      URL.revokeObjectURL(fileUrl);

      return response.data;
    } catch (error) {
      console.error("Error downloading motion heatmap report:", error);
      throw error;
    }
  },
);

export const mptionHeatMapReportSlice = createSlice({
  name: "motionHeatMapReport",
  initialState,
  reducers: {
    setFilterFormConfig(state, action) {
      state.filterFormConfig = action.payload;
    },
    getFilterFormConfig(state) {
      return state.filterFormConfig;
    },
    setTcOptions(state, action) {
      state.tcOptions = action.payload;
    },
    setSiteOptions(state, action) {
      state.siteOptions = action.payload;
    },
    setBlockOptions(state, action) {
      state.blockOptions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMotionHeatMapReports.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getMotionHeatMapReports.fulfilled, (state, action) => {
      state.isLoading = false;
      state.motionHeatMapReports = action.payload;
    });
    builder.addCase(getMotionHeatMapReports.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(downloadMotionHeatMapReportsFile.pending, (state) => {
      state.isLoadingMotionHeatmapReportsDownload = true;
    });
    builder.addCase(
      downloadMotionHeatMapReportsFile.fulfilled,
      (state, action) => {
        state.isLoadingMotionHeatmapReportsDownload = false;
        state.motionHeatmapReportsDownload = action.payload;
      },
    );
    builder.addCase(
      downloadMotionHeatMapReportsFile.rejected,
      (state, action) => {
        state.isLoadingMotionHeatmapReportsDownload = false;
        state.error = action.error.message;
      },
    );
  },
});

export const {
  setFilterFormConfig,
  getFilterFormConfig,
  setTcOptions,
  setSiteOptions,
  setBlockOptions,
} = mptionHeatMapReportSlice.actions;

export default mptionHeatMapReportSlice.reducer;
